/**
 * Mirrors `packages/types/src/local-agent-auth.ts` so the published CLI does not depend on `@buildautomaton/types`.
 */

const LOCAL_AGENT_AUTH_ERROR_HINTS: Record<string, RegExp[]> = {
  'kiro-acp': [/not logged in/i, /kiro-cli\s+login/i, /log in with kiro-cli/i],
  'cursor-cli': [/cursor_login/i, /authenticate.*cursor/i, /not logged in.*cursor/i, /run:\s*agent\s+login/i],
  'codex-acp': [
    /authentication failed/i,
    /not authenticated/i,
    /invalid.*api key/i,
    /sign in.*openai/i,
    /login.*openai/i,
    /unauthorized/i,
  ],
  'claude-code': [
    /ANTHROPIC_API_KEY/i,
    /not authenticated/i,
    /authentication failed/i,
    /claude\s+login/i,
    /please run.*claude.*login/i,
  ],
};

export function localAgentErrorSuggestsAuth(
  agentType: string | undefined | null,
  errorText: string | undefined | null
): boolean {
  if (agentType == null || agentType === '' || errorText == null || !String(errorText).trim()) return false;
  const hints = LOCAL_AGENT_AUTH_ERROR_HINTS[agentType];
  if (!hints?.length) return false;
  return hints.some((re) => re.test(String(errorText)));
}
